/**
 * @generated SignedSource<<9999110b4596a616b93a534124c916b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CutOffListDownload_cutOffListDownload$data = {
  readonly label: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "CutOffListDownload_cutOffListDownload";
};
export type CutOffListDownload_cutOffListDownload$key = {
  readonly " $data"?: CutOffListDownload_cutOffListDownload$data;
  readonly " $fragmentSpreads": FragmentRefs<"CutOffListDownload_cutOffListDownload">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CutOffListDownload_cutOffListDownload",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "SimpleLink",
  "abstractKey": null
};

(node as any).hash = "698ce84cd30c02c384fd9e2cf24ce2ed";

export default node;
